// Saikrishna 27/10/2022 3075234474 Scheduling functionality --> ,Reccurence Pattern- weekly(bugs formik)
// Prakash 28/10/2022 3075234474 Scheduling UI Enhancements --> ,Added Styling Classes for UI enhancements -->
// akhila 03/11/2022 3075234474 get api integration and data prepopulation
// Prakash Gummala 11/02/2022 3075234474 Fixed Responsiveness for 768px.
// akhila  11/11/2022 3075234474 fixed validations issues
// akhila 11/11/2022 3075234474 fixed week validations
// akhila 11/22/2022 3075234474 fixed data prepopulation issues in nightJobsScheduler
// akhila 11/11/2022 3075234474 added new UI Fields for Reports
// Saikrishna 11/30/2022 2701350359  required changes dne for reports
// Sai Maheshwar 11/30/2022 2701350359  re-arranged fields
// akhila 12/23/2022 2701350359 removed Recur Every week
// Prakash 07/04/2023 2701350359 fixed check box color
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@material-ui/core';
import React from 'react';

const WeeklySchedule = ({values, setFieldValue, handleChange, touched, errors, handleBlur}) => {
  return (
    <>
      <div className="col-sm-12 col-lg-8 check-box-color">
        <FormGroup row className="mt-3">
          <FormControlLabel
            control={
              <Checkbox
                value="MON"
                id="mon"
                name="mon"
                checked={values?.mon ? true : false}
                onChange={(e) => setFieldValue('mon', e.target.checked)}
              />
            }
            label="Monday"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="TUE"
                id="tue"
                name="tue"
                checked={values?.tue ? true : false}
                onChange={(e) => setFieldValue('tue', e.target.checked)}
              />
            }
            label="Tuesday"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="WED"
                id="wed"
                name="wed"
                checked={values?.wed ? true : false}
                onChange={(e) => setFieldValue('wed', e.target.checked)}
              />
            }
            label="Wednesday"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="THU"
                id="thu"
                name="thu"
                checked={values?.thu ? true : false}
                onChange={(e) => setFieldValue('thu', e.target.checked)}
              />
            }
            label="Thursday"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="FRI"
                id="fri"
                name="fri"
                checked={values?.fri ? true : false}
                onChange={(e) => setFieldValue('fri', e.target.checked)}
              />
            }
            label="Friday"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="SAT"
                id="sat"
                name="sat"
                checked={values?.sat ? true : false}
                onChange={(e) => setFieldValue('sat', e.target.checked)}
              />
            }
            label="Saturday"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="SUN"
                id="sun"
                name="sun"
                checked={values?.sun ? true : false}
                onChange={(e) => setFieldValue('sun', e.target.checked)}
              />
            }
            label="Sunday"
          />
        </FormGroup>
        <div>
          {
            <FormHelperText margin="dense">
              {touched.weeks && errors.weeks && errors.weeks}
            </FormHelperText>
          }
        </div>
      </div>
    </>
  );
};

export default WeeklySchedule;
